// tableFloatingMenuActions.js
// Command dispatch and enablement checks for table floating menu actions.
// Single Responsibility: this module owns the "how to run a table command" concern,
// keeping it separate from the tooltip lifecycle (TableFloatingMenuTooltip) and
// the UI shape (TableFloatingMenuComponent / tableFloatingMenuConfigs).

import {
    addColumnAfter,
    addColumnBefore,
    addRowAfter,
    addRowBefore,
    deleteColumn,
    deleteRow,
    deleteTable,
    mergeCells,
    splitCell,
    toggleHeaderCell,
} from "prosemirror-tables";

/**
 * Map of actionType string → prosemirror-tables command function.
 * Centralised here so both isEnabled checks and dispatch share the same source.
 */
export const TABLE_COMMANDS = {
    addRowBefore,
    addRowAfter,
    addColumnBefore,
    addColumnAfter,
    deleteRow,
    deleteColumn,
    deleteTable,
    mergeCells,
    splitCell,
    toggleHeaderCell,
};

/**
 * Returns true when the given command can currently execute.
 *
 * @param {string} actionType
 * @param {EditorState} state
 * @param {EditorView} view
 * @returns {boolean}
 */
export function isTableActionEnabled(actionType, state, view) {
    const cmd = TABLE_COMMANDS[actionType];
    if (!cmd) return false;
    return cmd(state, null, view);
}

/**
 * Execute a table command and return focus to the editor.
 *
 * @param {string} actionType
 * @param {EditorView} view
 */
export function dispatchTableAction(actionType, view) {
    const cmd = TABLE_COMMANDS[actionType];
    if (!cmd) return;
    cmd(view.state, view.dispatch, view);
    view.focus();
}
